module.exports = __webpack_public_path__ + "img/loginbg.c2d26bee.png";